<template>
  <div id="dados-da-empresa">
    <div class="q-pa-md">
      <div class="text-right q-mb-md ">
        <q-btn
          flat
          round
          class="q-mr-sm"
          icon="settings"
          color="primary"
          @click="openModalOptions()"
        />
        <q-btn
          outline
          color="negative"
          label="Limpar registros"
          @click="openModalComecarDoZero()"
          :disable="disableBotaoComecarDoZero"
        />
      </div>

      <div class="q-col-gutter-md row">
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.cnpj"
            label="CNPJ"
            readonly
            bottom-slots
            :error="errors.cnpj ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.cnpj" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.tfls"
            mask="###"
            label="TFLs"
            bottom-slots
            :error="errors.tfls ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.tfls" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.codigo"
            maxlength="20"
            counter
            label="Identificador"
            bottom-slots
            :error="errors.codigo ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.codigo" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.razao"
            label="Razão"
            readonly
            bottom-slots
            :error="errors.razao ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.razao" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.fantasia"
            maxlength="100"
            label="Fantasia"
            bottom-slots
            :error="errors.fantasia ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.fantasia" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col col-md-2" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.cep"
            label="CEP"
            bottom-slots
            :error="errors.cep ? true : false"
            mask="#####-###"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.cep" :key="error + i">{{error}}</span>
            </template>
            <template v-if="perfil.empresa.cep" v-slot:append>
              <q-btn
                :loading="buscandoCEP"
                name="search"
                clickable
                @click.stop="consultaCEP(perfil.empresa.cep)"
                :disable="buscandoCEP"
                icon="search"
                dense
                class="cursor-pointer bg-positive"
                color="text-white"
              >
                <template v-slot:loading>
                  <q-spinner color="grey-10" size="1em" />
                </template>
              </q-btn>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.cidade"
            maxlength="100"
            label="Cidade"
            bottom-slots
            :error="errors.cidade ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.cidade" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col col-md-2" v-if="perfil.empresa">
          <q-select
            v-model="perfil.empresa.estado"
            :options="estadosShort"
            label="Estado"
            bottom-slots
            :error="errors.estado ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.estado" :key="error + i">{{error}}</span>
            </template>
          </q-select>
        </div>
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.bairro"
            maxlength="100"
            label="Bairro"
            bottom-slots
            :error="errors.bairro ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.bairro" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.endereco"
            maxlength="255"
            label="Endereço"
            bottom-slots
            :error="errors.endereco ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.endereco" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col col-md-2" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.numero"
            maxlength="20"
            counter
            label="Número"
            bottom-slots
            :error="errors.numero ? true : false"
            id="numero"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.numero" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-4" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.complemento"
            maxlength="255"
            label="Complemento"
            bottom-slots
            :error="errors.complemento ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.complemento" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.atividade"
            maxlength="255"
            label="Atividade"
            bottom-slots
            :error="errors.atividade ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.atividade" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <q-input
            v-model="perfil.empresa.telefone"
            maxlength="20"
            counter
            label="Telefone"
            bottom-slots
            :error="errors.telefone ? true : false"
          >
            <template v-slot:error>
              <span v-for="(error, i) in errors.telefone" :key="error + i">{{error}}</span>
            </template>
          </q-input>
        </div>
        <div class="col-12 col-md-6" v-if="perfil.empresa">
          <ImageInput
            title="Logo da Empresa"
            :hasImage="hasImage"
            :imageUrl="imageUrl"
            :loading="loadingFile"
            @fileUploaded="handleFileUpload"
            @fileRemoved="removerLogo"
          />

          <p class="text-caption">A imagem deve ser no formato .png, 80px de largura e 45px de altura.</p>
        </div>
        <div class="col-12 q-mt-lg" v-if="perfil.empresa">
          <q-btn
            no-wrap
            v-ripple
            label="Salvar"
            no-caps
            class="q-ml-sm q-px-md bg-positive text-white absolute-bottom-right"
            style="margin: 0 30px 20px 0"
            clickable
            type="submit"
            :loading="loadEdit"
            @click="salvar()"
          >
            <template v-slot:loading>
              <q-spinner color="grey-10" size="1em" />
            </template>
          </q-btn>
        </div>
      </div>
    </div>

  <q-dialog v-model="modalComecarDoZero" persistent>
      <q-card style="max-width: 500px; width: 100%;">
        <q-card-section class="row items-center no-wrap bg-grey-2">
          <div class="text-h6">Limpar registros</div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            v-close-popup
            @click="closeModalComecarDoZero()"
          />
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pa-md scroll" style="max-height: 70vh">
          
          <div class="bg-grey-1 q-pa-md rounded-borders">
            <div class="text-subtitle1 q-mb-xs text-weight-bold text-primary">
              1. O que deseja excluir?
            </div>
            
            <div class="row q-col-gutter-sm">
              <div class="col-12">
                <q-checkbox
                  label="Cadastros (Clientes, Funcionários...)"
                  v-model="comecarDoZeroOptions.cadastros"
                  dense
                />
              </div>

              <div class="col-12">
                <q-checkbox
                  label="Produtos, Serviços, Loterias"
                  v-model="comecarDoZeroOptions.produtos"
                  dense
                />
              </div>

              <div class="col-12">
                <q-checkbox
                  label="Contas a Pagar (Despesas)"
                  :disable="opcaoDespesasDesabilitado"
                  v-model="comecarDoZeroOptions.despesas"
                  dense
                />
              </div>

              <div class="col-12">
                <q-checkbox
                  label="Contas a Receber (Receitas)"
                  :disable="opcaoReceitasDesabilitado"
                  v-model="comecarDoZeroOptions.receitas"
                  dense
                />
              </div>

              <div class="col-12">
                <q-checkbox
                  label="Lançamento de Caixas"
                  :disable="opcaoCaixasDesabilitado"
                  v-model="comecarDoZeroOptions.caixas"
                  dense
                />
              </div>

              <div class="col-12">
                <q-checkbox
                  label="Estoque"
                  :disable="opcaoEstoqueDesabilitado"
                  v-model="comecarDoZeroOptions.estoque"
                  dense
                />
              </div>
            </div>
          </div>

          <div v-if="step === 1" class="row justify-end q-mt-md">
            <q-btn
              color="primary"
              label="Enviar Código de Segurança"
              icon="send"
              :loading="sendingEmail"
              :disable="!algumaOpcaoSelecionada"
              @click="enviarCodigo()"
              class="full-width"
            />
          </div>

          <q-slide-transition>
            <div v-if="step === 2" class="q-mt-lg bg-grey-1 q-pa-md rounded-borders" style="border: 1px solid #ddd">
              <div class="text-subtitle1 q-mb-xs text-weight-bold text-primary">
                2. Confirmação de Segurança
              </div>
              
              <p class="text-caption text-grey-8 q-mb-md">
                Enviamos um código para seu e-mail. Digite-o abaixo para confirmar a exclusão.
              </p>

              <q-input
                v-model="verificationCode"
                label="Código de 6 dígitos"
                mask="######"
                bg-color="white"
                autofocus
                dense
                class="q-mb-md"
                :error="verificationCode.length > 0 && verificationCode.length < 6"
                error-message="Digite os 6 números"
              >
                <template v-slot:append>
                  <q-icon name="lock" />
                </template>
              </q-input>

              <div class="row items-center justify-between q-mb-md">
                 <div class="text-caption text-grey-8">
                  <span v-if="resendTimer > 0">
                    Reenviar em {{ resendTimer }}s
                  </span>
                  <span v-else>
                    <a 
                      href="#" 
                      class="text-primary cursor-pointer text-weight-bold" 
                      style="text-decoration: none;" 
                      @click.prevent="enviarCodigo"
                    >
                      Reenviar código
                    </a>
                  </span>
                </div>
              </div>

              <q-separator class="q-mb-md" />

              <div class="column q-gutter-y-sm">
                <q-btn
                  color="negative"
                  label="CONFIRMAR EXCLUSÃO"
                  icon="delete_forever"
                  size="lg"
                  :loading="loadingComecarDoZero"
                  :disable="verificationCode.length < 6"
                  @click="confirmarComecarDoZero()"
                  class="full-width"
                />
                
                <q-btn
                  flat
                  color="grey-8"
                  label="Cancelar"
                  size="sm"
                  @click="step = 1; verificationCode = ''"
                  class="full-width"
                />
              </div>
            </div>
          </q-slide-transition>

        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="modalOptions" persistent>
      <q-card style="max-width: 400px; width: 90%;">
        <q-card-section class="row items-center">
          <div class="text-h6">Opções</div>
          <q-space />
          <q-btn
            flat
            round
            dense
            icon="close"
            v-close-popup
            @click="closeModalOptions()"
          />
        </q-card-section>
        <q-separator/>
        <q-card-section class="q-pa-md">
          <div class="row q-col-gutter-lg">
            <div class="col-12">
              <q-checkbox
                label="Validar CPF e CNPJ repetidos"
                v-model="options.empresa_validar_cpf_cnpj_repetidos"
                true-value="1"
                false-value="0"
                color="green"
              />
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div class="col-12">
            <q-input
              v-model="options.empresa_responsavel_id"
              label="ID do Cadastro Responsável da Empresa"
              stack-label
            />
          </div>
        </q-card-section>
        <q-card-section>
          <div class="col-12">
            <q-input
              v-model="options.empresa_destinatario_recursos_id"
              label="ID do Cadastro do Destinatário dos Recursos."
              stack-label
            />
          </div>
        </q-card-section>
        <q-card-section>
          <div class="col-12">
            <q-input
              v-model="options.empresa_responsavel_transporte_id"
              label="ID do Cadastro da Empresa de Transporte de Valores"
              stack-label
            />
          </div>
        </q-card-section>
        <q-card-section align="right">
          <q-btn
            label="Salvar"
            clickable
            v-ripple
            @click="salvarOpcoes()"
            :loading="salvandoOpcoes"
            color="green"
            text-color="white"
            style="margin-right: 22px; margin-bottom: 10px"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import globalAxios from "axios";
import { mapGetters } from "vuex";
import { Loading, Dialog, Notify } from "quasar";
import { mensagemDeErro, errosDeCampo } from "@/utils/erros-api";
import ImageInput from '../Utils/image-input.vue';

export default {
  name: "dados-da-empresa",
  components: { ImageInput },
  data() {
    return {
      perfil: {},
      errors: [],
      loadEdit: false,
      buscandoCEP: false,
      buscandoCNPJ: false,
      maxLogoSize: 500 * 1024,
      arquivos: [],
      imagemUploadErro: '',
      
      sendingEmail: false,
      step: 1,
      verificationCode: '',
      resendTimer: 0,
      timerInterval: null,

      modalComecarDoZero: false,
      loadingComecarDoZero: false,
      disableBotaoComecarDoZero: false,
      comecarDoZeroOptions: {
        textoConfirmacao: '',
        cadastros: false,
        produtos: false,
        receitas: false,
        despesas: false,
        caixas: false,
        estoque: false,
      },
      modalOptions: false,
      options: {
        empresa_validar_cpf_cnpj_repetidos: "0",
        empresa_responsavel_id: null,
        empresa_responsavel_transporte_id: null,
        empresa_destinatario_recursos_id: null,
      },
      optionsOriginais: {
        empresa_validar_cpf_cnpj_repetidos: "0",
      },
      salvandoOpcoes: false,
      hasImage: false,
      imageUrl: '',
      loadingFile: false
    };
  },
  methods: {
    consultaCEP() {
      if (!this.perfil.empresa.cep) {
        Notify.create({
          message: "CEP Inválido, digite novamente.",
          color: "orange",
          position: "top-right"
        });
      }

      let cep = this.perfil.empresa.cep;
      cep = cep.replace(/\D/g, "");
      // Expressão regular para validar o CEP.
      let validacep = /^[0-9]{8}$/;
      // Valida o formato do CEP.
      if (!validacep.test(cep) || cep === "") {
        if (cep !== "") {
          Notify.create({
            message: "CEP Inválido, digite novamente.",
            color: "orange",
            position: "top-right"
          });
        }
      }
      this.buscandoCEP = true;

      globalAxios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then(res => {
          let data = res.data;
          if (!("erro" in data)) {
            Notify.create({
              message: "CEP encontrado!",
              color: "green",
              position: "top-right"
            });
            this.perfil.empresa.endereco = data.logradouro;
            this.perfil.empresa.cidade = data.localidade;
            this.perfil.empresa.bairro = data.bairro;
            this.perfil.empresa.estado = data.uf;
            this.perfil.empresa.numero = "";
            document.getElementById("numero").focus();
          } else {
            Notify.create({
              message: "CEP não encontrado.",
              color: "orange",
              position: "top-right"
            });
          }
          this.buscandoCEP = false;
        })
        .catch(() => {
          // Consulta ao ViaCEP (axios global, sem o interceptor do app): a falha aqui
          // é de rede ou do serviço externo — permissão nunca esteve em jogo.
          Notify.create({
            message: "Não foi possível consultar o CEP. Preencha o endereço manualmente.",
            color: "red",
            position: "top-right"
          });
          this.buscandoCEP = false;
        });
    },
    listar(response) {
      axios.get("/empresas/edit/" + response.id).then(res => {
        if (res.data.success) {
          this.perfil = res.data;

          if (this.perfil.empresa.logo_url) {
            this.hasImage = true;
            this.imageUrl = this.perfil.empresa.logo_url;
          }
        }
      });
    },
    salvar() {
      this.loadEdit = true;
      Dialog.create({
        title: "Deseja Alterar os dados da Empresa?",
        cancel: "Cancelar",
        persistent: true
      })
        .onOk(() => {
          Loading.show();
        })
        .onOk(() => {
          axios
            .post("/empresas/edit", this.perfil.empresa)
            .then(res => {
              // O interceptor de axios-auth resolve erro HTTP como { error }, então a
              // falha chega aqui e não no .catch().
              if (res.error) {
                this.errors = errosDeCampo(res.error) || {};
                Dialog.create({
                  title: mensagemDeErro(res.error, "salvar os dados da empresa"),
                  class: "bg-negative text-white",
                  ok: {
                    "text-color": "red",
                    color: "white"
                  }
                });
                this.loadEdit = false;
                Loading.hide();
                return;
              }

              if (res.data.success) {
                Dialog.create({
                  title: res.data.message,
                  class: "bg-positive text-white",
                  ok: {
                    "text-color": "green",
                    color: "white"
                  }
                });
              } else {
                Dialog.create({
                  title: res.data.message,
                  class: "bg-warning text-white",
                  ok: {
                    "text-color": "orange",
                    color: "white"
                  }
                });
                this.errors = res.data.errors;
              }
              this.loadEdit = false;
            })
            .catch(() => {
              Dialog.create({
                title: "Não foi possível salvar os dados da empresa. Tente novamente.",
                class: "bg-negative text-white",
                ok: {
                  "text-color": "red",
                  color: "white"
                }
              });
              this.loadEdit = false;
              Loading.hide();
            });
        })
        .onCancel(() => {
          Loading.hide();
        })
        .onDismiss(() => {
          Loading.hide();
        });
    },
    async buscaEmpresa() {
      let response = await this.$store.getters.dataEmpresa;

      this.listar(response);
    },
    openModalComecarDoZero() {
      this.modalComecarDoZero = true;
    },
    closeModalComecarDoZero() {
      this.modalComecarDoZero = false;
      // Reseta o estado ao fechar
      setTimeout(() => {
        this.step = 1;
        this.verificationCode = '';
        this.resendTimer = 0;
        if(this.timerInterval) clearInterval(this.timerInterval);
      }, 300);
    },
    confirmarComecarDoZero() {
      const data = JSON.parse(JSON.stringify(this.comecarDoZeroOptions));
      
      // Adiciona o código ao payload
      data.code = this.verificationCode;

      this.loadingComecarDoZero = true;

      axios
        .post('/empresas/comecar-novamente', data)
        .then(res => {
          this.loadingComecarDoZero = false;

          if (!res.data.success) {
            Notify.create({
              message: res.data.message, // A API deve retornar se o código for inválido aqui
              color: 'orange',
              position: 'top-right',
            });
            return;
          }

          window.location.href = window.location.origin;
          this.disableBotaoComecarDoZero = true;
          this.closeModalComecarDoZero();
        })
        .catch(() => {
          this.loadingComecarDoZero = false;
          Notify.create({
            message: 'Houve um erro ao processar a solicitação.',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    openModalOptions() {
      this.modalOptions = true;

      axios
        .get("/empresas/options")
        .then(res => {
          if (res.error) {
            Notify.create({
              message: mensagemDeErro(res.error, "carregar as configurações"),
              color: "red",
              position: "top-right",
            });
            return;
          }

          // O guarda original era `if (!res.data.message)`, e o GET sempre devolve
          // `message` ("Sucesso ao recuperar opções", EmpresasController.php:515):
          // nunca disparava, e se disparasse notificaria um `undefined`. Quem decide
          // se houve recusa é o `success`.
          if (res.data.success === false) {
            Notify.create({
              message: res.data.message,
              color: "orange",
              position: "top-right",
            });
            return;
          }

          this.optionsOriginais = res.data.options;
          this.options = res.data.options;
        })
        .catch(() => {
          Notify.create({
            message: "Não foi possível carregar as configurações. Tente novamente.",
            color: "red",
            position: "top-right",
          });
        });
    },
    closeModalOptions() {
      this.modalOptions = false;
    },
    salvarOpcoes() {
      if (this.salvandoOpcoes) return;

      this.salvandoOpcoes = true;

      axios
        .post("/empresas/options", this.options)
        .then(res => {
          this.salvandoOpcoes = false;

          if (res.error) {
            Notify.create({
              message: mensagemDeErro(res.error, "salvar as configurações"),
              color: "red",
              position: "top-right"
            });
            return;
          }

          Notify.create({
            message: res.data.message,
            color: res.data.success ? "green" : "orange",
            position: "top-right"
          });

          if (!res.data.success) {
            return;
          }

          this.options = res.data.options;

          this.closeModalOptions();
        })
        .catch(() => {
          this.salvandoOpcoes = false;
          Notify.create({
            message: "Houve um erro ao salvar as opções, tente novamente!",
            color: "red",
            position: "top-right"
          });
        });
    },
    handleFileUpload(file) {
      if (!file) return;
      this.loadingFile = true;

      const fd = new FormData();
      fd.append("logo", file);

      axios
        .post("/empresas/edit?imagem=1", fd, { headers: { "Content-Type": "multipart/form-data" } })
        .then(res => {
          this.loadingFile = false;
          // axios-auth resolves HTTP errors as { error }
          if (res.error) {
            this.avisarFalhaLogo();
            return;
          }
          if (!res.data.success) {
            if (res.data.error) {
              Dialog.create({
                title: res.data.error,
                class: "bg-negative text-white",
                ok: {
                  "text-color": "red",
                  color: "white"
                }
              });
            } else {
              Notify.create({
                message: res.data.message,
                color: "red",
                position: "top-right"
              });
            }
            return;
          }

          this.hasImage = true;
          this.imageUrl = res.data.logo;
          this.dataEmpresa.logo_url = res.data.logo;
          this.perfil.empresa.logo_url = res.data.logo;
          Notify.create({
            message: res.data.message,
            color: "green",
            position: "top-right"
          });
        });
    },
    removerLogo() {
      Dialog.create({
        title: "Tem certeza que deseja remover a logo da empresa?",
      }).onOk(() => {
        this.loadingFile = true;

        axios
          .post("/empresas/edit?imagem=2")
          .then(res => {
            if (res.data.success) {
              Notify.create({
                message: "Logo da empresa removido com sucesso!",
                color: "green",
                position: "top-right"
              });
              this.hasImage = false;
              this.imageUrl = "";
              this.perfil.empresa.logo_url = null;
              this.dataEmpresa.logo_url = null;
            } else {
              Notify.create({
                message: "Houve um erro ao remover logo da empresa",
                color: "red",
                position: "top-right"
              });
              this.errors = res.data.errors;
            }
            this.loadingFile = false;
          })
          .catch(() => {
            // axios-auth resolves HTTP errors as { error }, so reading res.data lands here.
            // Released before the dialog: the image input's Loading overlay sits above it.
            this.loadingFile = false;
            this.avisarFalhaLogo();
          });
      });
    },
    avisarFalhaLogo() {
      Dialog.create({
        title:
          "Não foi Possível realizar a ação, ou você não possui permissão isto!",
        class: "bg-negative text-white",
        ok: {
          "text-color": "red",
          color: "white"
        }
      });
    },
    startResendTimer() {
      this.resendTimer = 60;
      if (this.timerInterval) clearInterval(this.timerInterval);
      
      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    enviarCodigo() {
      if (!this.algumaOpcaoSelecionada) return;

      this.sendingEmail = true;

      axios.post('/empresas/send-token')
        .then(res => {
          this.sendingEmail = false;
          
          if (res.data.success) {
            Notify.create({
              message: "Código enviado para seu e-mail com sucesso!",
              color: "green",
              position: "top-right"
            });
            
            this.step = 2;
            this.startResendTimer();
          } else {
            Notify.create({
              message: res.data.message || "Erro ao enviar e-mail.",
              color: "orange",
              position: "top-right"
            });
          }
        })
        .catch(() => {
          this.sendingEmail = false;
          Notify.create({
            message: "Erro de conexão ao enviar código.",
            color: "red",
            position: "top-right"
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      'token',
      'dataEmpresa'
    ]),
    algumaOpcaoSelecionada() {
      return (
        this.comecarDoZeroOptions.cadastros || 
        this.comecarDoZeroOptions.produtos ||
        this.comecarDoZeroOptions.receitas ||
        this.comecarDoZeroOptions.despesas ||
        this.comecarDoZeroOptions.caixas ||
        this.comecarDoZeroOptions.estoque
      );
    },
    opcaoCaixasDesabilitado() {
      return this.comecarDoZeroOptions.cadastros || this.comecarDoZeroOptions.produtos;
    },
    opcaoEstoqueDesabilitado() {
      return this.comecarDoZeroOptions.cadastros || this.comecarDoZeroOptions.produtos;
    },
    opcaoReceitasDesabilitado() {
      return this.comecarDoZeroOptions.cadastros;
    },
    opcaoDespesasDesabilitado() {
      return this.comecarDoZeroOptions.cadastros;
    },
  },
  watch: {
    'comecarDoZeroOptions.cadastros'(value) {
      if (value) {
        this.comecarDoZeroOptions.caixas = true;
        this.comecarDoZeroOptions.estoque = true;
        this.comecarDoZeroOptions.despesas = true;
        this.comecarDoZeroOptions.receitas = true;
      }
    },
    'comecarDoZeroOptions.produtos'(value) {
      if (value) {
        this.comecarDoZeroOptions.caixas = true;
        this.comecarDoZeroOptions.estoque = true;
      }
    },
  },
  mounted() {
    this.buscaEmpresa();
  },
};
</script>

<style lang="stylus" scoped>
  .disable-item {
    pointer-events: none;
    opacity: 0.6;
  }
</style>
